import { combineReducers } from "redux";
import { layoutReducer } from "./layout ";
import { authReducer } from "./authReducer";
import orderReducer from "./orderReducer";
import { ordersReducer } from "./ordersDetails";

export const reducers = combineReducers({
  auth: authReducer,
  layout: layoutReducer,
  order: orderReducer,
  orders: ordersReducer,
});
